import { useEffect } from 'react'

interface DisableInertProps {
  root?: string
}

export function DisableInert({ root = '__next' }: DisableInertProps) {
  useEffect(() => {
    const rootNode = document.getElementById(root)
    if (rootNode) {
      rootNode.inert = false
    }
  }, [root])

  return null
}
